export function isMac(): boolean {
	return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
}

export function isMobile(): boolean {
	if (typeof window !== 'undefined') {
		if (
			window.navigator.userAgent.match(/Android/i) ||
			window.navigator.userAgent.match(/webOS/i) ||
			window.navigator.userAgent.match(/iPhone/i) ||
			window.navigator.userAgent.match(/iPad/i) ||
			window.navigator.userAgent.match(/iPod/i) ||
			window.navigator.userAgent.match(/BlackBerry/i) ||
			window.navigator.userAgent.match(/Windows Phone/i)
		) {
			return true;
		} else {
			return false;
		}
	}
	return false;
};

const KEY_MODIFIERS = ['ctrl', 'alt', 'shift'];

export function keyForDisplay(key: string): string {
	const lowerKey = key.trim().toLowerCase();

	if (KEY_MODIFIERS.includes(lowerKey)) {
		return lowerKey.toUpperCase();
	}

	if (lowerKey.length > 1) {
		return lowerKey.substring(0, 1).toUpperCase() + lowerKey.substring(1);
	}

	return key.trim();
}

export function kbShortcutStringToComponents(
	shortcut: string,
	localize: boolean = true,	// Converts Mod to system rep
	forDisplay: boolean = false // Make the output pretty
): Array<string> {
	const result: Array<string> = [];

	const components = shortcut.split('+');

	for (let component of components) {
		component = component.trim();

		if (component.length === 0) {
			continue;
		}

		if (localize && component.toLowerCase() === 'mod') {
			let ctrl = (isMac()) ? '⌘' : 'ctrl';

			if (forDisplay) {
				ctrl = keyForDisplay(ctrl);
			}
			result.push(ctrl);
		} else if (component.toLowerCase() === 'enter') {
			result.push('⏎');
		} else {
			if (forDisplay) {
				component = keyForDisplay(component);
			}
			result.push(component);
		}
	}

	return result;
}

export function copyTextToClipboard(text: string): Promise<any> {
	const data = [
		//@ts-ignore
		new ClipboardItem(
			{
				"text/plain": new Blob(
					[text],
					{ type: "text/plain" }
				)
			}
		)
	];

	//@ts-ignore
	return window.navigator.clipboard.write(data);
}

// https://github.com/ueberdosis/tiptap/blob/develop/packages/core/src/utilities/isRegExp.ts#L1
export function isRegExp(value: any): value is RegExp {
	return Object.prototype.toString.call(value) === '[object RegExp]';
}

/**
 * https://github.com/ueberdosis/tiptap/blob/develop/packages/core/src/utilities/objectIncludes.ts#L8
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */
export function objectIncludes(
	object1: Record<string, any>,
	object2: Record<string, any>,
	options: { strict: boolean } = { strict: true },
): boolean {
	const keys = Object.keys(object2);

	if (!keys.length) {
		return true;
	}

	return keys.every(key => {
		if (options.strict) {
			return object2[key] === object1[key];
		}

		if (isRegExp(object2[key])) {
			return object2[key].test(object1[key]);
		}

		return object2[key] === object1[key];
	})
}

const VALID_SUBDOMAIN_CHARSET = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-_';

/**
 * Takes a string and makes it safe for use
 * as a subdomain
 */
export function stringToSubdomain(input: string): string {
	input = input.replace(/ /g, '-');
	input = input.toLowerCase();
	input = input.trim();

	let result = '';
	for (let c of input) {
		if (VALID_SUBDOMAIN_CHARSET.includes(c)) {
			result += c;
		}
	}

	return result;
}
